"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

var _ComposeEditInterstitialModal = _interopRequireDefault(require("ComposeUI/components/modals/ComposeEditInterstitialModal"));

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _ContentGroups = _interopRequireDefault(require("ComposeUI/data/model/ContentGroups"));

var _reactRedux = require("react-redux");

var _FavoriteBlog = _interopRequireDefault(require("ComposeUI/data/model/FavoriteBlog"));

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _Modals = _interopRequireDefault(require("ComposeUI/data/model/Modals"));

var _OnboardingModal = _interopRequireDefault(require("ComposeUI/components/modals/OnboardingModal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save
  };
};

var mapDispatchToProps = {};

var ModalsContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ModalsContainer, _Component);

  function ModalsContainer() {
    (0, _classCallCheck2.default)(this, ModalsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModalsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(ModalsContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          auth = _this$props.auth,
          composerSettings = _this$props.composerSettings,
          composition = _this$props.composition,
          contentGroups = _this$props.contentGroups,
          favoriteBlog = _this$props.favoriteBlog,
          lock = _this$props.lock,
          modalOpen = _this$props.modals.modalOpen,
          savePost = _this$props.savePost,
          saveState = _this$props.saveState,
          userSettings = _this$props.userSettings;
      return _react.default.createElement("div", null, _react.default.createElement(_ComposeEditInterstitialModal.default, {
        auth: auth,
        composerSettings: composerSettings,
        composition: composition,
        contentGroups: contentGroups,
        dismissModal: this.props.dismissModal,
        favoriteBlog: favoriteBlog,
        lock: lock,
        modalOpen: modalOpen,
        savePost: savePost,
        saveState: saveState
      }), _react.default.createElement(_OnboardingModal.default, {
        dismissModal: this.props.dismissModal,
        modalOpen: modalOpen,
        openOnboardingModal: this.props.openOnboardingModal,
        userId: auth.user.get('user_id'),
        userSettings: userSettings
      }));
    }
  }]);
  return ModalsContainer;
}(_react.Component);

ModalsContainer.propTypes = {
  auth: _propTypes.default.instanceOf(_Auth.default).isRequired,
  composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
  composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
  contentGroups: _propTypes.default.instanceOf(_ContentGroups.default).isRequired,
  dismissModal: _propTypes.default.func.isRequired,
  favoriteBlog: _propTypes.default.instanceOf(_FavoriteBlog.default),
  lock: _propTypes.default.instanceOf(_Lock.default),
  modals: _propTypes.default.instanceOf(_Modals.default),
  openOnboardingModal: _propTypes.default.func.isRequired,
  savePost: _propTypes.default.func.isRequired,
  saveState: _propTypes.default.instanceOf(_SaveState.default),
  userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalsContainer);

exports.default = _default;
module.exports = exports.default;